module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_8004.15aa2864.png";